import { render, staticRenderFns } from "./QuotaAmount.vue?vue&type=template&id=7e099cac&"
import script from "./QuotaAmount.vue?vue&type=script&lang=js&"
export * from "./QuotaAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e099cac')) {
      api.createRecord('7e099cac', component.options)
    } else {
      api.reload('7e099cac', component.options)
    }
    module.hot.accept("./QuotaAmount.vue?vue&type=template&id=7e099cac&", function () {
      api.rerender('7e099cac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/point/PointQuotaLimit/components/QuotaAmount.vue"
export default component.exports